module.exports = __webpack_public_path__ + "img/page-top-img.771b404a.jpg";